export default __webpack_public_path__ + "static/media/smile-plushie.3733c9b4.jpg";